import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";
import { Navbar } from "@/components/Navbar";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    const r = await register(name, email, password);
    setBusy(false);
    if (r.ok) {
      toast.success("Account initialized");
      navigate("/dashboard");
    } else {
      setErr(r.error);
      toast.error(r.error);
    }
  };

  return (
    <div className="min-h-screen bg-background bg-grid scanlines">
      <Navbar />
      <main className="mx-auto max-w-md px-6 py-16">
        <div className="border border-border bg-card">
          <div className="border-b border-border px-6 py-4 flex items-center justify-between">
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">// auth · register</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-primary">new operator</div>
          </div>
          <form onSubmit={submit} className="p-6 space-y-5" data-testid="register-form">
            <div>
              <h1 className="font-display font-bold text-3xl">Initialize your account.</h1>
              <p className="mt-2 text-sm text-muted-foreground font-mono">{">"} join the GTGS focus network</p>
            </div>

            <div className="space-y-2">
              <Label className="font-mono text-[11px] uppercase tracking-widest" htmlFor="name">display_name</Label>
              <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required className="rounded-none font-mono" placeholder="Your name" data-testid="register-name-input" />
            </div>

            <div className="space-y-2">
              <Label className="font-mono text-[11px] uppercase tracking-widest" htmlFor="email">email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-none font-mono" placeholder="you@team.com" data-testid="register-email-input" />
            </div>

            <div className="space-y-2">
              <Label className="font-mono text-[11px] uppercase tracking-widest" htmlFor="password">password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="rounded-none font-mono" placeholder="At least 6 characters" data-testid="register-password-input" />
            </div>

            {err && (
              <div className="border border-destructive/40 bg-destructive/10 text-destructive font-mono text-xs px-3 py-2" data-testid="register-error">
                ! {err}
              </div>
            )}

            <Button type="submit" disabled={busy} className="w-full rounded-none font-mono uppercase tracking-widest h-11" data-testid="register-submit-button">
              {busy ? "Initializing…" : "Create Account"}
            </Button>

            <div className="font-mono text-xs text-muted-foreground text-center space-y-1">
              <div>
                {">"} already onboarded?{" "}
                <Link to="/login" className="text-primary underline-offset-4 hover:underline" data-testid="register-to-login-link">
                  login
                </Link>
              </div>
              <div>
                {">"} can't remember your password?{" "}
                <Link to="/forgot-password" className="text-primary underline-offset-4 hover:underline" data-testid="register-forgot-password-link">
                  reset it
                </Link>
              </div>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}
